export default __webpack_public_path__ + "static/media/copy-icon.3da6b637.svg";